import React from "react";
import { MyCustomContextHook } from "./Context";
import courseData from "./sidebar-data";
import EachCourse from "./EachCourse";


const SideBar = () => {
  const { isSidebarOpen, sideBarClosed } = MyCustomContextHook();

  return (
    <>
      <aside
        className={`${
          isSidebarOpen ? "sidebar-wrapper show" : "sidebar-wrapper"
        }`}
      >
        <button onClick={sideBarClosed} className="close-btn">
          <i className="ri-close-line"></i>
        </button>
        <div className="sidebar">
          <div className="resgister-btn">
            <span>Login</span>
            <span>Sign Up</span>
          </div>

          <div className="sidebar-links">
            <div className="courses">
              <h2 className="courses-text">Most Popular</h2>
              <ul>
                <li>
                  {courseData.map((course) => {
                    return (
                      <>
                        <EachCourse key={course.id} {...course} />
                      </>
                    );
                  })}
                </li>
              </ul>
              <div className="more-stuff">
                <div className="more-stuff-wrapper">
                  <div className="stuff-header">
                    <h2>More from Udemy</h2>
                  </div>
                  <div className="more-container">
                    <div className="more-container-wrapper">
                      <h3>Udemy Business</h3>
                      <h3>Get the App</h3>
                      <h3>Invite Friends</h3>
                      <h3>Help</h3>
                    </div>
                    <button>
                      <i className="ri-global-line"></i>
                      <h3>English</h3>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default SideBar;
